export default function getValueAtPath(object, key) {
  let splitedKey = key.split('.');
  return splitedKey.reduce((acc, curr) => {
    return acc ? acc[curr] : null;
  }, object);
}
